<template>
    <div class="main_event_info_widget">
        <div v-if="!event.is_online && event.address" class="info_row">
            <span class="img"><img src="../assets/img/map.svg" alt="map"></span>
            <span>{{$t(`EventInfoWidget['Offline event']`)}}</span>
        </div>
        <div v-else class="info_row">
            <span class="img"><img src="../assets/img/webcam.svg" alt="webcam-icon"></span>
            <span>{{$t(`EventInfoWidget['Online event']`)}}</span>
        </div>
        <div class="info_row">
            <span class="img"><img src="../assets/img/date.svg" alt="date"></span>
            <span>{{ eventDate }}</span>
        </div>
        <div class="info_row">
            <span class="img"><img src="../assets/img/seat.svg" alt="seat"></span>
            <span>{{ seatsInfo }} seats</span>
        </div>
        <div class="info_row">
            <span class="img"><img src="../assets/img/room-size.svg" alt="room-size"></span>
            <span>{{ roomSize }}</span>
        </div>
        <div class="info_row">
            <span class="img"><img src="../assets/img/duration.svg" alt="duration"></span>
            <span>{{ conversationDuration }}</span>
        </div>
        <div class="info_row b0">
            <span class="img"><img src="../assets/img/location.svg" alt="location"></span>
            <span>{{ eventLocation }}</span>
        </div>
        <div v-if="!event.is_online && event.address" class="info_row icon-less b0">
            <span>{{ event.address }}</span>
        </div>
        <div v-if="!event.is_online && event.additional_info" class="info_row icon-less b0">
            <span>{{ event.additional_info }}</span>
        </div>
        <div v-if="!event.is_online && event.lat && event.lng" class="info_row icon-less">
            <span>Lat: {{ event.lat }} Long: {{ event.lng }}</span>
        </div>
        <div v-if="!event.is_online && event.lat && event.lng" class="info_row map_btn">
            <span
                @click="showMapHandler"
            >{{$t(`EventInfoWidget['See on map']`)}}</span>
        </div>
        <div class="info_row">
            <span class="img"><img src="../assets/img/host.svg" alt="host"></span>
            <span>{{$t(`EventInfoWidget['Host:']`)}}</span>
            <span>{{ event.organisation }}</span>
        </div>

        <!-- buttons -->
        <div
            class="btn_wrapper"
            v-if="btn_wrapper['view_btn_wrapper'] && event.hasOwnProperty('is_reserved', )"
        >
            <div class="btn"
                 v-if="event.is_reserved"
                 @click="cancelReservation"
            > {{$t(`buttons['Cancel reservation']`)}}
            </div>

            <div class="btn"
                 v-else
                 @click="reserveSeat"
            >
                {{$t(`buttons['Reserve a seat']`)}}
            </div>
        </div>
        <div id="map_address_modal" ref="map_address_modal" class="modal">
            <div class="modal_header">
                {{$t(`modals['Location on map']`)}}

                <div class="close_modal"
                     @click="closedMapModalHandler"
                >
                    <img src="../assets/img/close.svg" alt="close mobile menu button">
                </div>
            </div>
            <div class="modal-content">
                <div class="map_box" ref="map_wrapper">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import {removeMapsScriptsFromHead} from "../../../admin_panel/src/services/tools";

export default {
    data() {
        return {
            map_modal: {
                instance: null,
                map: null
            }
        }
    },
    methods: {
        cancelReservation() {
            this.$emit('cancel_reservation');
        },
        reserveSeat() {
            this.$emit('reservation');
        },
        clearModal() {
            if (this.map_modal.instance) {
                this.map_modal.instance?.destroy();
                this.map_modal.instance = null;
            }
        },
        initModal() {
            this.clearModal();
            this.map_modal.instance = M.Modal.init(this.$refs.map_address_modal, {
                dismissible: false,
                startingTop: '1%',
                endingTop: '5%'
            })
        },
        openMapModal() {
            if (!this.map_modal.instance) {
                this.initModal();
            }
            this.map_modal.instance?.open();
        },
        closedMapModalHandler() {
            this.map_modal.instance?.close();
        },
        showMapHandler() {
            this.openMapModal();
        },
        MapsInit() {
            if (!this.event?.lat || !this.event?.lng) {
                return;
            }
            if (!window?.google?.maps) {
                setTimeout(_ => {
                    this.MapsInit();
                }, 500);
                return;
            }
            this.initModal();
            // const latLng = new google.maps.LatLng(this.event.lat, longitude);

            const myLatLng = {lat: parseFloat(this.event.lat), lng: parseFloat(this.event.lng)};
            !this.map_modal.map && (this.map_modal.map = new google.maps.Map(this.$refs.map_wrapper, {
                zoom: 12,
                center: myLatLng,
            }));
            this.placeMarker({latLng: myLatLng});
        },
        placeMarker(event) {
            const location = event.latLng
            if (!this.map_modal.marker) {
                this.map_modal.marker = new google.maps.Marker({
                    position: location,
                    map: this.map_modal.map
                });
            } else {
                this.map_modal.marker.setPosition(location);
            }
        },
    },
    beforeDestroy() {
        this.clearModal();
        removeMapsScriptsFromHead();
    },
    metaInfo() {
        if (window?.google?.maps) {
            return {};
        }
        return {
            script: [{
                vmid: 'google-maps-autocomplete',
                src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCPv_T-pHqaTKYP91yOjX6ARZpH52h8paM&libraries=places&language=en`,
                async: true,
                defer: true,
                callback: () => this.MapsInit()
            }]
        }
    },
    computed: {
        eventDate() {
            return moment(this.event.start_date_time).format('DD.MM.YYYY, HH:mm');
        },
        eventPast() {
            let now = moment();
            const date = moment(this.event.start_date_time);
            return moment.duration(date.diff(now)).minutes();
        },
        seatsInfo() {
            return `${this.event.seats_min} - ${this.event.seats_max || '---'}`;
        },
        eventDuration() {
            return `1 - 2.5 hours`;
        },
        tagsString() {
            const tags = this.event?.tags || [];
            return tags.map(el => el.title)?.join(', ') || '';
        },
        eventLocation() {
            return `${this.event.location || '---'}`;
        },
        ageInfo() {
            return `${this.$t("EventInfoWidget['Age limit:']")} ${this.event.age_from} - ${this.event.age_to}`;
        },
        conversationDuration() {
            return `${this.event.conversation_duration} ${this.$t("EventInfoWidget['min for conversation']")}`;
        },
        roomSize() {
            return `${this.event.conversation_users_count} ${this.$t("EventInfoWidget['users per conversation']")}`;
        }
    },
    props: [
        'event',
        'btn_wrapper'
    ],
    mounted() {
    },
    watch: {
        event(val) {
            if (val && val.lat && val.lng) {
                this.MapsInit();
            }
        }
    },
    name: "EventInfoWidget"
}
</script>

<style lang="scss" scoped>

#map_address_modal {
    height: 90vh;
    max-height: 90vh;

    .map_box {
        height: calc(90vh - 50px);
    }

    .modal-content {
        padding: 0;
    }

    .close_modal {
        position: absolute;
        right: 20px;
        cursor: pointer;
    }
}

.info_row {
    &.map_btn {
        justify-content: center;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: #FA604A;
        cursor: pointer;
    }

    &.icon-less {
        padding-left: 18px;
    }

    &.b0 {
        padding-bottom: 0;
    }
}

.btn_wrapper {
    padding: 15px 0 !important;

    .btn {
        svg {
            margin-right: 10px;
        }
    }
}

.main_event_info_widget, .col.main_event_info_widget {
    padding: 15px;
}
</style>
